import { Component, Input, Output, forwardRef, OnInit, EventEmitter, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { StateService, AuthService, CustomerService, ScriptService, SquareService } from '../../services';
import { Authenticate, CustomerModel, CustomerRegistrationRequestModel } from '../../models';
import { FormFunctions } from '../../functions';

@Component({
    selector: 'customer-profile',
    templateUrl: './customer-profile.component.html'
})
export class CustomerProfileComponent implements OnInit {
    processing: boolean = false;
    error: string = "";
    customer: CustomerModel;
    states: string[] = [
        'ACT',
        'NSW',
        'NT',
        'QLD',
        'SA',
        'TAS',
        'VIC',
        'WA',
    ];
    @Output() onSuccess: EventEmitter<any> = new EventEmitter();

    constructor(public router: Router,
        private renderer: Renderer2,
        private scriptService: ScriptService,
        private activatedRoute: ActivatedRoute,
        public stateService: StateService,
        public authService: AuthService,
        public customerService: CustomerService,
        public formFunctions: FormFunctions,
    ) {
        let me = this;

    }

    ngOnInit() {
        let me = this;

        me.processing = true;
        me.customerService.CurrentCustomer().subscribe(data => {
            // console.log('CurrentCustomer', data);
            me.customer = data;
            me.processing = false;
        });
    }

    async UpdateProfile(form, e) {
        let me = this;
        me.error = "";

        if (me.formFunctions.isFormValid(form, e)) {
            me.processing = true;
            me.customerService.UpdateProfile(me.customer).subscribe(data => {
                // console.log('UpdateProfile', data);
                me.processing = false;

                // Clear the cache by running an immediate request to retrieve the customer with Cache-Control: no-cache
                // Otherwise we could continue retrieving old results when they reload.
                me.customerService.serviceHelper.NoCacheNextRequest();
                me.customerService.getCustomer();

                me.onSuccess.emit('success');
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });

            }, err => {
                me.processing = false;
                me.error = "Something went wrong. Please try again"

                if (err.status != 401) {
                    if (err?.error?.Message) me.error = err?.error?.Message;
                }
            });
        } else {
            me.error = "Please complete all fields.";
        }
    }
}



